import { render, staticRenderFns } from "./orderProductionPreview.vue?vue&type=template&id=a08ce65c&scoped=true&"
import script from "./orderProductionPreview.vue?vue&type=script&lang=js&"
export * from "./orderProductionPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08ce65c",
  null
  
)

export default component.exports